import ModelInterface from "../../interfaces/model/ModelInterface";
import {useEffect, useState} from "react";
import ModelImageInterface from "../../interfaces/model/ModelImageInterface";
import {DEFAULT_SHOP_ID} from "../../Config";

export default function useModel(model: ModelInterface | undefined, inSelectedColor: string = '') {
    const [selectedColor, setSelectedColor] = useState( inSelectedColor || '');
    const [selectedSize, setSelectedSize] = useState('');

    const getImages = () => model?.images.filter(image => !(image.type === 'print')) || []

    useEffect(() => {
        if (!isSizeAvailable(selectedSize)) {
            setSelectedSize('')
        }
    }, [selectedColor])

    useEffect(() => {
        setSelectedColor(inSelectedColor)
    }, [inSelectedColor]);

    const getImagesByColor = (): ModelImageInterface[] => {
        if (!model?.images) {
            return [];
        }
        return getImages().filter(image => image.special_color_name?.toLowerCase() === selectedColor?.toLowerCase())
    }

    const getAvailableSpecialColors = () => {
        return model?.items.map(modelItem => {
            return modelItem.color_special
        }).filter((value, index, array) => {
            return array.indexOf(value) === index;
        })
    }

    const getFrontImages = (): ModelImageInterface[] => {
        if (!model?.images) {
            return [];
        }
        const existSpecialColors = getAvailableSpecialColors() || []

        return model?.images.filter(image => image.type === "front").filter(image => existSpecialColors.find(color => color.toLowerCase() === image.special_color_name.toLowerCase()))
    }

    const getCurrentColorName = (): string => {
        const firstItem = model?.items.find(item => item.color_special?.toLowerCase() === selectedColor?.toLowerCase());
        return firstItem ? firstItem.color : "No color"
    }

    const isSizeAvailable = (size: string, shopId = DEFAULT_SHOP_ID): boolean => {
        const item = model?.items.find(item => item.size === size && item.color_special?.toLowerCase() === selectedColor?.toLowerCase())
        if (!item) {
            return false;
        }
        const retailStock = item?.stocks?.find(stock => stock.shop_id === shopId)


        if (!retailStock) {
            return false;
        }

        return retailStock.quantity > 0
    }

    const getSelectedFrontImage = (): ModelImageInterface | undefined => {
        if (!model?.images) {
            return undefined;
        }
        return model?.images.find(image => image.type === "front" && image.special_color_name?.toLowerCase() === selectedColor?.toLowerCase())
    }

    const getImageAlt = (): string => {
        return model?.inetshop_name + ' Baon ' + model?.articul
    }

    return {getImagesByColor, getFrontImages, getCurrentColorName, isSizeAvailable, getSelectedFrontImage, getImageAlt}
}